<template>
  <div class="flex flex-row justify-between items-center">
    <div>
      <h2 class="capitalize mb-0">{{ title }}</h2>
    </div>

    <slot name="header-action" />
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TabHeader',

  props: {
    title: {
      type: String,
      required: true,
    },
  },

  setup() {
    return {}
  },
})
</script>
